import { InnerBlocks, useBlockProps } from '@wordpress/block-editor';

/**
 * Save component for the inline container block.
 * This handles how the block is saved to content.
 *
 * @return {JSX.Element} Element to render.
 */
export const Save = () => {
	const blockProps = useBlockProps.save();

	return (
		<>
			<div { ...blockProps }>
				{ /* @ts-ignore */ }
				<InnerBlocks.Content />
			</div>
		</>
	);
};
